import { mount } from 'svelte'

import createEduUndergraduateStores from '../stores/createEduUndergraduateStores'


import AnimatedValue from '../../components/projects/facts-and-figures/core/dataviz/AnimatedValue.svelte'
import DecorativeDonut from '../../components/projects/facts-and-figures/composite/DecorativeDonut.svelte'
import DecorativeHorizontalBars from '../../components/projects/facts-and-figures/composite/DecorativeHorizontalBars.svelte'
import GenericDonut from '../../components/projects/facts-and-figures/highcharts/GenericDonut.svelte'
import LabelValueParagraph from '../../components/projects/facts-and-figures/core/visual/LabelValueParagraph.svelte'
import OpenBottomDonut from '../../components/projects/facts-and-figures/composite/OpenBottomDonut.svelte'
import PressGaneyDounut from '../../components/projects/facts-and-figures/composite/PressGaneyDonut.svelte'
import SoloBarChart from '../../components/projects/facts-and-figures/composite/SoloBarChart.svelte'
import StandardDonut from '../../components/projects/facts-and-figures/composite/StandardDonut.svelte'
import ThreeColList from '../../components/projects/facts-and-figures/core/ThreeColList.svelte'
import Ghost from '../../components/lib/Ghost.svelte'

/**
 * Fetch data for Edu Undergraduate; Mount home components with data
 */
export default function () {
  const [
    data,
    loading,
    error,
    
    eduundertotalonlyDerived,
    eduUnderActDerived,
    eduUnderGpaDerived,
    eduUnderByProgDerived,
    eduUnderGenDerived,
  ] = createEduUndergraduateStores()

  if(document.getElementById('undergrad-total')) {
    mount(DecorativeDonut, {
      target: document.getElementById('undergrad-total'),
      props: {
        store: eduundertotalonlyDerived
      }
    })
  }

  if(document.getElementById('pubhealth-scores')) {
    mount(LabelValueParagraph, {
      target: document.getElementById('pubhealth-scores'),
      props: {
        store: eduUnderActDerived
      }
    })
  }

  if(document.getElementById('medsci-scores')) {
    mount(LabelValueParagraph, {
      target: document.getElementById('medsci-scores'),
      props: {
        store: eduUnderGpaDerived
      }
    })
  }

  if(document.getElementById('undergrad-by-race')) {
    mount(GenericDonut, {
      target: document.getElementById('undergrad-by-race'),
      props: {
        dataUrl: 'https://webcentral.uc.edu/scorecard/eduunder-raceJson.cfm'
      }
    })
  }

  if(document.getElementById('ghost-gen')) {
    mount(Ghost, {
      target: document.getElementById('ghost-gen'),
      props: {
        data: data,
        store: eduUnderGenDerived,
        dataFunction: (dataArray)=>{
          console.log('the dataArray for eduUnderGenDerived', dataArray)
          dataArray.forEach((item, index)=>{
            if (item[1] >= 10) {
              $("#gender").append('<div index="0" class="gen-bar' + index + ' ' + item[0].toLowerCase() + ' " style=" max-width:' + item[1] + '%;"> <span>' + item[0] + ' ' + item[1] + '%<span></div>');
            } else {
              $(".gen-legend").append('<li> <a href="#" class="gen-bar-link' + index + ' ' + item[0].toLowerCase() + '"> <span class="label">' + item[0] + ' </span><span class="value">' + item[1] + '%</span></div>');
            }
          })
        }
      }
    })
  }

  if(document.getElementById('ghost-byProg')) {
    mount(Ghost, {
      target: document.getElementById('ghost-byProg'),
      props: {
        store: eduUnderByProgDerived,
        dataFunction: (dataArray)=>{
          console.log('the dataArray for eduUnderByProgDerived', dataArray)
          dataArray.forEach((item, index)=>{
            $("#totalStu").append('<div tab-index="0" class="stu-bar' + index + ' ' + item[0].toLowerCase() + ' " style=" max-width:50%;"><span>' + item[0] + ' ' + item[1] + '<span></div>');
          })
        }
      }
    })
  }
}